import Vue from "vue";
import DatePicker from "vue2-datepicker";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { TH_SARABUN_TTF_BASE64 } from "@/assets/fonts/thsarabun.js";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  components: {
    DatePicker,
    Paginate,
  },
  data: function () {
    return {
      busy: false,
      date_start: null,
      date_end: null,
      perPage: 6,
      sortBy: "name",
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      totalItem: 0,
      apiStatus: "กรุณาระบุวันที่และกดปุ่มแสดงข้อมูลเพื่อค้นหาข้อมูล",
      fields: [
        {
          key: "index",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "document_no",
          label: "เลขที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "created_at",
          label: "วันที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "document_date",
          label: "กำหนดชำระ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "customer",
          label: "ชื่อลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "creator_detail.name",
          label: "ผู้จัดทำ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "total",
          label: "ยอดลด ฿",
          sortable: true,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "font-weight-bold text-black td-top text-xs-1/2",
          class: "text-right",
        },
        {
          key: "remark",
          label: "หมายเหตุ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
      ],
      items: [],
      form: {
        sale_id: null,
        start_date: new Date(moment().startOf("month").format("YYYY-MM-DD")),
        end_date: new Date(moment().endOf("month").format("YYYY-MM-DD")),
      },
      seller_list: [],
      sum: 0,
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  methods: {
    async onInitData() {
      try {
        const item = this.items;
        this.items = [];
        this.busy = true;
        this.apiStatus = "กำลังค้นหาข้อมูล..";

        const res = await this.$axios.get(
          this.$host +
            "/api/v1/report/credit-note?keyword_startdate=" +
            moment(this.form.start_date).format("YYYY-MM-DD") +
            "&keyword_enddate=" +
            moment(this.form.end_date).format("YYYY-MM-DD")
        );

        const data = res.data;

        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.items = data.data;
        this.sum = data.total;
      } catch (error) {
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async onLoadEmployee() {
      try {
        this.loading = true;
        const res = await this.$axios.get(
          this.$host + "/api/v1/document/quotation/branch/employee"
        );

        const newObj = { name: "--- ทั้งหมด ---", id: null };
        this.seller_list = res.data;

        this.seller_list.unshift(newObj);

        this.loading = false;
      } catch (error) {
        this.loading = false;

        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    // ฟอนต์ไทย (มีไฟล์แล้วค่อยเรียกใช้)
    addThaiFont(doc) {
      if (!doc || !TH_SARABUN_TTF_BASE64) return;
      doc.addFileToVFS("THSarabun.ttf", TH_SARABUN_TTF_BASE64);
      doc.addFont("THSarabun.ttf", "THSarabun", "normal");
      doc.addFont("THSarabun.ttf", "THSarabun", "bold");
    },

    // ---------- Export PDF (A4 landscape) ----------
    exportCreditPDF() {
      if (!this.items || this.items.length === 0) {
        this.$bvToast.toast("ไม่มีข้อมูลให้ส่งออก", {
          title: "Export PDF",
          variant: "warning",
          solid: true,
        });
        return;
      }

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: "a4",
      });
      this.addThaiFont?.(doc);
      doc.setFont?.("THSarabun", "normal");

      const margin = { top: 80, right: 36, bottom: 48, left: 36 };
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();

      const title = "รายงานลดหนี้";
      const period = `ช่วงวันที่: ${moment(this.form.start_date).format(
        "DD/MM/YYYY"
      )} - ${moment(this.form.end_date).format("DD/MM/YYYY")}`;

      const drawHeader = () => {
        doc.setFontSize(18);
        doc.setFont?.("THSarabun", "bold");
        doc.text(title, margin.left, 40);
        doc.setFontSize(12);
        doc.setFont?.("THSarabun", "normal");
        doc.text(period, margin.left, 60);
      };
      const drawFooter = (n) => {
        doc.setFontSize(11);
        doc.text(`หน้า ${n}`, pageW - margin.right, pageH - 20, {
          align: "right",
        });
      };

      let pageNo = 1;
      drawHeader();
      drawFooter(pageNo);

      // หัวตาราง (พอดี A4 หลังหัก margin รวม ~720pt)
      const head = [
        [
          "#", // 0: 24
          "เลขที่เอกสาร", // 1: 90
          "วันที่เอกสาร", // 2: 70
          "กำหนดชำระ", // 3: 70
          "ชื่อลูกค้า", // 4: 160
          "ผู้จัดทำ", // 5: 110
          "ยอดลด ฿", // 6: 80 (ชิดขวา)
          "หมายเหตุ", // 7: 120
        ],
      ];

      const col = {
        0: { cellWidth: 24, halign: "right" },
        1: { cellWidth: 90 },
        2: { cellWidth: 70 },
        3: { cellWidth: 70 },
        4: { cellWidth: 160 },
        5: { cellWidth: 110 },
        6: { cellWidth: 80, halign: "right" },
        7: { cellWidth: 120 },
      };

      const fmtDate = (d) =>
        d
          ? new Date(d).toLocaleDateString("th-TH", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })
          : "-";

      const money = (n) =>
        parseFloat(n || 0).toLocaleString("th-TH", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

      // แปลง items -> rows
      const body = this.items.map((it, i) => {
        const comp = it?.delivery_document?.customer?.company_name || "-";
        const name = it?.delivery_document?.customer?.name || "";
        const customer = name ? `${comp}\n(${name})` : comp; // ขึ้นบรรทัดใหม่กันล้น
        return [
          i + 1,
          it?.document_no || it?.delivery_document?.document_no || "-",
          fmtDate(it?.created_at),
          fmtDate(it?.document_date),
          customer,
          it?.creator_detail?.name || "-",
          money(it?.total),
          it?.remark || "-",
        ];
      });

      // ตารางหลัก
      doc.autoTable({
        startY: margin.top,
        head,
        body,
        margin,
        pageBreak: "auto",
        tableWidth: "wrap",
        styles: {
          font: "THSarabun",
          fontSize: 10,
          cellPadding: 3,
          overflow: "linebreak",
          lineColor: [220, 220, 220],
          lineWidth: 0.2,
          valign: "middle",
        },
        headStyles: {
          fillColor: [240, 240, 240],
          textColor: 20,
          halign: "center",
        },
        columnStyles: col,
        didDrawPage: (data) => {
          if (data.pageNumber > pageNo) {
            pageNo = data.pageNumber;
            drawHeader();
            drawFooter(pageNo);
          }
        },
      });

      // แถวสรุปท้าย (ใช้ this.sum ถ้ามี ไม่งั้นรวมเอง)
      const grand =
        this.sum || this.items.reduce((a, it) => a + (+it.total || 0), 0);
      doc.autoTable({
        startY: (doc.lastAutoTable ? doc.lastAutoTable.finalY : margin.top) + 6,
        theme: "plain",
        margin,
        styles: { font: "THSarabun", fontSize: 12, cellPadding: 6 },
        columnStyles: col,
        body: [["", "", "", "", "", "ยอดรวมทั้งหมด", money(grand), ""]],
      });

      const fn = `รายงานลดหนี้_${new Date().toLocaleDateString("th-TH")}.pdf`;
      doc.save(fn);
    },

    // ---------- Export Excel ----------
    exportCreditExcel() {
      if (!this.items || this.items.length === 0) {
        this.$bvToast.toast("ไม่มีข้อมูลให้ส่งออก", {
          title: "Export Excel",
          variant: "warning",
          solid: true,
        });
        return;
      }

      const fmtDate = (d) =>
        d
          ? new Date(d).toLocaleDateString("th-TH", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })
          : "-";
      const rows = this.items.map((it, i) => ({
        "#": i + 1,
        เลขที่เอกสาร:
          it?.document_no || it?.delivery_document?.document_no || "-",
        วันที่เอกสาร: fmtDate(it?.created_at),
        กำหนดชำระ: fmtDate(it?.document_date),
        บริษัท: it?.delivery_document?.customer?.company_name || "-",
        ชื่อลูกค้า: it?.delivery_document?.customer?.name || "",
        ผู้จัดทำ: it?.creator_detail?.name || "-",
        "ยอดลด ฿": +parseFloat(it?.total ?? 0),
        หมายเหตุ: it?.remark || "-",
      }));

      const ws = XLSX.utils.json_to_sheet(rows);
      ws["!cols"] = [
        { wch: 4 }, // #
        { wch: 18 }, // เลขที่เอกสาร
        { wch: 14 }, // วันที่เอกสาร
        { wch: 14 }, // กำหนดชำระ
        { wch: 24 }, // บริษัท
        { wch: 18 }, // ชื่อลูกค้า
        { wch: 16 }, // ผู้จัดทำ
        { wch: 14 }, // ยอดลด ฿
        { wch: 30 }, // หมายเหตุ
      ];

      // ฟอร์แมตตัวเลข
      const ref = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = ref.s.r + 1; R <= ref.e.r; R++) {
        const amt = XLSX.utils.encode_cell({ r: R, c: 7 }); // คอลัมน์ "ยอดลด ฿"
        if (ws[amt]) ws[amt].z = "#,##0.00";
      }

      // แถวสรุปท้ายชีต
      const totalRow = ref.e.r + 2;
      const labelCell = XLSX.utils.encode_cell({ r: totalRow - 1, c: 6 });
      const valCell = XLSX.utils.encode_cell({ r: totalRow - 1, c: 7 });
      const sumVal =
        +this.sum || rows.reduce((a, r) => a + (r["ยอดลด ฿"] || 0), 0);
      ws[labelCell] = { t: "s", v: "ยอดรวมทั้งหมด" };
      ws[valCell] = { t: "n", v: sumVal, z: "#,##0.00" };

      ws["!autofilter"] = { ref: ws["!ref"] };

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "รายงานลดหนี้");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const fn = `รายงานลดหนี้_${new Date().toLocaleDateString("th-TH")}.xlsx`;
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), fn);
    },
  },
  async mounted() {
    await this.onLoadEmployee();
  },
};
